import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import { DocumentKind, ServiceKind } from "@bitory-gmbh/bsm";

export interface UseDocumentPathParams {
  documentId: string;
  documentKind: DocumentKind;
  serviceKind: ServiceKind;
  processId: string | null;
}

export interface UseDocumentPathReturn {
  path: string | null;
}

export function useDocumentPath({
  documentId,
  documentKind,
  serviceKind,
  processId,
}: UseDocumentPathParams): UseDocumentPathReturn {
  if (!processId) {
    // If no processId is provided, we cannot create a valid path.
    return { path: null };
  }
  const akPath = documentKindPath(documentKind);
  const path = `/processes/${serviceKind}/${processId}/${akPath}/${documentId}`;

  return { path };
}

function documentKindPath(documentKind: DocumentKind): string {
  if (documentKind === GSMDocumentKind.WorkOrder) {
    return "work-orders";
  }

  return `${documentKind}s`;
}
